import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { NavigationExtras } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import { CrudService } from 'src/app/pages/admin/services/crud/crud.service';
import { AccountModel } from 'src/models/accounts/account';
import { ConferenceStatus, ConferencType, ConnectionStatus, VideoConference } from 'src/models/video-conference';
import {StorageService} from './storage.service';

export interface ConvInfo {
    path: string;
    accountId: string;
    proileId: string;
    expertName: string;
    conversationType: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConversationService {
  private  path: string;
  private  accountId: string;
  private  proileId: string;
  private  expertName: string;
  private conversationType: string;
  private conversation = {} as ConvInfo;

  constructor(
      private storageService: StorageService,
      private afAuth: AngularFireAuth,
      private firestore: AngularFirestore,
      private modalController: ModalController,
      private crudService: CrudService<AccountModel, object>,
      private translate: TranslateService,
      private navCtrl: NavController
      ) {
        this.path = window.localStorage.getItem('convInfoPath');
        this.proileId = window.localStorage.getItem('convInfoProfileId');
        this.expertName = window.localStorage.getItem('convInfoExpertName');
        this.accountId = window.localStorage.getItem('convInfoAccountId');
        this.conversationType = window.localStorage.getItem('convInfoConversationType');
  }

  getConversation() {
    return {path: this.path, accountId: this.accountId, profileId: this.proileId, expertName: this.expertName};
  }

  getConversationInfo(): Promise<{path: string, accountId: string, profileId: string, expertName: string}> {
    return new Promise((resolve, reject) => {
      resolve({path: this.path, accountId: this.accountId, profileId: this.proileId, expertName: this.expertName});
    });
  }


  setConversation(data: ConvInfo) {
    this.conversation = data;
    this.path = data.path;
    this.proileId = data.proileId;
    this.expertName = data.expertName;
    this.accountId = data.accountId;
    this.conversationType = data.conversationType;
    window.localStorage.setItem('convInfoPath', this.path);
    window.localStorage.setItem('convInfoProfileId', this.proileId);
    window.localStorage.setItem('convInfoExpertName', this.expertName);
    window.localStorage.setItem('convInfoAccountId', this.accountId);
    window.localStorage.setItem('convInfoConversationType', this.conversationType);
  }

  deleteConversation() {
    this.conversation = null;
    this.storageService.setValue('convInfo', this.conversation);
  }



  // tslint:disable-next-line:max-line-length
  public async connectToDoctor() { // path = profileRef => accound/id/profile/id



    if (this.conversationType === 'video') {


      const videoConference = {} as VideoConference;
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(account => {
            if (account) {
              const data = account.data() as AccountModel;
              videoConference.createdAt = new Date();
              videoConference.subscriberId = user.uid;
              videoConference.connectionStatus = ConnectionStatus.not_started;
              videoConference.subscriberFullName = data.name;
              videoConference.expertFullName = this.expertName;
              videoConference.expertPath = this.path;
              videoConference.expertId = this.proileId;
              videoConference.expertAccountId = this.accountId;
              videoConference.status = ConferenceStatus.pending;
              videoConference.payStatus = false;
              videoConference.type = ConferencType.video;
              videoConference.roomName = this.expertName + '/video-call/room/name/' + this.firestore.createId();
              this.firestore.collection('videoConference').add(Object.assign({}, videoConference)).then(res => {
                this.crudService.showAlertComplete(
                  this.translate.instant('request_header_conversation'),
                  this.translate.instant('request_sended_to_expert_check_your_appointments'),
                  this.translate.instant('okay')
                );
                this.modalController.dismiss(null, null, 'ChooseDoctorList');
                this.modalController.dismiss(null, null, 'ChooseDoctor');
              }).catch(err => {
                console.log(err);
              });

            }
          }).catch(errAccount => {
            console.log(errAccount);
          });
        }
      }).then().catch(err => {
        console.log(err);
      });


    }
    if (this.conversationType === 'voice') {
      const videoConference = {} as VideoConference;
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(account => {
            if (account) {
              const data = account.data() as AccountModel;
              videoConference.createdAt = new Date();
              videoConference.subscriberId = user.uid;
              videoConference.connectionStatus = ConnectionStatus.not_started;
              videoConference.subscriberFullName = data.name;
              videoConference.expertFullName = this.expertName;
              videoConference.expertPath = this.path;
              videoConference.expertId = this.proileId;
              videoConference.expertAccountId = this.accountId;
              videoConference.status = ConferenceStatus.pending;
              videoConference.payStatus = false;
              videoConference.type = ConferencType.audio;
              videoConference.roomName = this.expertName + '/audio-call/room/name/' + this.firestore.createId();
              this.firestore.collection('videoConference').add(Object.assign({}, videoConference)).then(res => {
                this.crudService.showAlertComplete(
                  this.translate.instant('request_header_conversation'),
                  this.translate.instant('request_sended_to_expert_check_your_appointments'),
                  this.translate.instant('okay')
                );
                this.modalController.dismiss(null, null, 'ChooseDoctorList');
                this.modalController.dismiss(null, null, 'ChooseDoctor');
              }).catch(err => {
                console.log(err);
              });

            }
          }).catch(errAccount => {
            console.log(errAccount);
          });
        }
      }).then().catch(err => {
        console.log(err);
      });
    }
    if (this.conversationType === 'chat') {
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          this.firestore.collection('accounts').doc(user.uid).get().toPromise().then(async account => {
            if (account) {
              this.modalController.dismiss(null, null, 'ChooseDoctorList');
              this.modalController.dismiss(null, null, 'ChooseDoctor');
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  subscriber: account.id,
                  path: this.path,
                  expert: this.accountId,
                  profileId: this.proileId
                }
              };
              await this.navCtrl.navigateForward(['./chatscreen'], navigationExtras);
            }
          }).catch(err => {
            console.log(err);
          });
        }
      });

    }

  }
}
